import { Col, Row, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { LinkOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import HeadingBack from "../../../component/HeadingBack";
import { usePermission } from "../../../hooks/usePermission";
import { AbhaServices } from "../../../redux/Services";
import ReportFilter from "./reportFilter";
import moment from "moment";
import dayjs from "dayjs";
import { AbhaLinkedNotify } from "../../../redux/Services/AbhaLinkded";
import { GetLoggedInUser, encryptedData } from "../../../utils";
const ReportList = () => {
  const [FilteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const permission = usePermission("HIP Dashboard", "List");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let LOG_IN_USER = GetLoggedInUser();
  const abhaCreatedList = useSelector(
    (state) => state.abhaCreated.ReportList || []
  );
  // const totalFaq = useSelector(state => state.faq.totalFaq || "");
  const [page, setPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState({});
  const [limit, setLimit] = useState(10);
  // const { mutate: getabhaReportList, isLoading } = useMutation((data) =>
  //   dispatch(AbhaServices.ReportList(data, limit, page))
  // );
  const { mutate: Notify, isLoading: addLoading } = useMutation((data) =>
    dispatch(AbhaLinkedNotify(data, navigate))
  );
  const { mutate: GetReportPdfApi } = useMutation((data) =>
    dispatch(AbhaServices.GetReportPdf(data))
  );
  const totalAbhaReportsLogs = useSelector(
    (state) => state.abhaCreated.totalAbhaReportsLogs || ""
  );
  const [raw, setRaw] = useState({});
  const [ModalNotify, setModalNotify] = useState(false);
  const handleNotify = () => {
    let hiuId = "LPL";
    let name = raw?.first_name + " " + raw?.last_name;
    let payload = {
      authMode: "DEMOGRAPHICS",
      purpose: "KYC_AND_LINK",
      type: "HIU",
      phrId: `${raw?.abha_address}`,
      referenceType: "Consent Request",
      lplLinkReference: `${raw?.abha_address || ""}`,
      platform: `${raw?.platform || "website"}`,
      platformType: `${raw?.platform_type || "creat abha page"}`,
      patientReference: `${raw?.patinet_id || ""}`,
      careContextReference: `${raw?.lab_number || ""}`,
      version: "v1",
      reportDateTime: `${raw?.report_date_time || ""}`,
      query: {
        id: `${raw?.abha_address || ""}`,
        purpose: "KYC_AND_LINK",
        requester: {
          type: "HIU",
          id: hiuId || ""
        },
        demographic: {
          name: `${name || ""}`,
          mobile_no: `${raw?.mobile_number || ""}`,
          gender: `${raw?.gender || ""}`,
          dateOfBirth: `${raw?.dob || ""}`
        }
      }
    };

    let _data = { ...payload };
    _data.customToken = true;
    // console.log(_data)
    // return false
    Notify(_data);
  };

  const disabledDate = (current) => {
    return current && current > dayjs().endOf("day");
  };
  const onChange = (value, dateString) => {
    // console.log('Selected Time: ', value);
    // console.log('Formatted Selected Time: ', dateString);
  };
  const onOk = (value) => {
    // console.log('onOk: ', value);
  };
  useEffect(() => {
    AbhaServices.ReportList({ ...filter, currentPage, limit }, dispatch);
    return () => {};
  }, [filter, limit, page, currentPage]);
  // console.log(abhaCreatedList?.setRaw);
  const handleDownloadReport = (e, reportId) => {
    e.preventDefault();
    GetReportPdfApi({
      ReportId: encryptedData(reportId),
      UserId: LOG_IN_USER?.UserId
    });
  };
  useEffect(() => {
    if (abhaCreatedList && abhaCreatedList.length > 0) {
      var data = [];
      abhaCreatedList.map((value, index) => {
        var item = {
          sno: value?.sno,
          log_type: value?.log_type,
          first_name: value?.first_name,
          last_name: value?.last_name,
          mobile_number: value?.mobile_number,
          heathid_no: value?.heathid_no,
          abha_address: value?.abha_address,
          lab_number: value?.lab_number,
          is_linked: value?.is_linked,
          report_date_time: value?.report_date_time,
          createdAt: value?.createdAt
        };

        data.push(item);
      });
      setFilteredData(data);
    }
    return () => {};
  }, [abhaCreatedList]);

  const headers = [
    { label: "S.No.", key: "sno" },
    { label: "Patient Name", key: "first_name" },
    { label: "ABHA Address", key: "abha_address" },
    { label: "Mobile Number", key: "mobile_number" },
    { label: "Lab Number", key: "lab_number" },
    { label: "Status", key: "is_linked" },
    { label: "Report Date and Time", key: "report_date_time" },
    { label: "Created Date Time", key: "createdAt" }
  ];

  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * limit + index + 1
    },
    // {
    //     title: 'Link and Notify',
    //     dataIndex: 'is_linked',
    //     key: 'action',
    //     className: 'abha-link-action',
    //     render: (value, record,index) => {
    //         // return (
    //         //     <> <Tooltip placement="top" title={"Link & Notify"}>
    //         //         <Button className="view-btn" type="primary" onClick={() => { setRaw(item || {}); setModalNotify(true);  }}><LinkOutlined /></Button>
    //         //     </Tooltip>
    //         //        </>
    //         // )
    //         return (record?.is_linked) ?
    //             ''
    //             : <Tooltip placement="top" title={"Link & Notify"}>
    //             <Button className="view-btn" type="primary" onClick={() => { setRaw(record || {}); setModalNotify(true); }}><LinkOutlined /></Button>
    //       </Tooltip>

    //     }
    // },
    {
      title: "Patient Name",
      dataIndex: "id",
      key: "id",
      className: "table_status_col",
      render: (value, item, index) => {
        return (
          <span>
            {item?.first_name} {item?.middle_name} {item?.last_name}
          </span>
        );
      }
    },

    {
      title: "Abha Address",
      dataIndex: "abha_address",
      key: "log_type",
      className: "table_status_col",
      name: "type"
    },
    {
      title: "Mobile Number",
      dataIndex: "mobile_number",
      key: "id",
      className: "text-capitalize"
    },

    {
      title: "Lab Number",
      dataIndex: "lab_number",
      key: "request_url",
      className: "table_status_col"
    },
    {
      title: "Visit ID",
      dataIndex: "visit_id",
      key: "visit_id",
      className: "table_status_col"
    },
    {
      title: "Report Date and Time",
      dataIndex: "requestor",
      key: "requestor",
      className: "w-200",
      render: (value, item, index) => {
        return (
          <span>
            <>{moment(item?.report_date_time).format("DD-MM-YYYY hh:mm")}</>
          </span>
        );
      }
    },

    {
      title: "Status",
      dataIndex: "raw_data",
      key: "raw_data",
      className: "table_status_col patient",
      render: (value, item, index) => {
        return (
          <span
            className={item?.is_linked ? "status_linked" : "status_pending"}
          >
            {item?.is_linked ? "Linked" : "Pending"}
          </span>
        );
      }
    },
    {
      title: "Report URL",
      dataIndex: "heathid_no",
      key: "health_id",
      className: "abha-link-date",
      render: (value, item, index) => {
        return (
          <span>
            {item?.pdf_url && (
              <a href="#" onClick={(e) => handleDownloadReport(e, item?.id)}>
                View Report
              </a>
            )}
          </span>
        );
      }
    },
    // {
    //     title: 'ABHA Address',
    //     dataIndex: 'health_id',
    //     key: 'health_id',
    //     width: 200
    // },

    {
      title: "Created Date Time",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "abha-link-date",
      render: (value, item, index) => {
        return <>{moment.utc(item.createdAt).format("DD-MM-YYYY H:mm:ss")}</>;
      }
    }
    // {
    //     title: 'Requested Data',
    //     dataIndex: 'action',
    //     key: 'action',
    //     className: 'table_status_col',
    //     render: (value, item, index) => {
    //         return (
    //             <><Button className="view-btn" type="primary" onClick={() => { setRaw(JSON.parse(item?.raw_data || "{}")); setModal1Open(true); }}> View</Button>
    //             </>
    //         )

    //     }
    // },
  ];
  return (
    <div>
      <Row gutter={[10, 10]} align={"middle"}>
        <Col lg={2} md={2} sm={24} xs={24}>
          <HeadingBack
            title={"Reports"}
            subHeading={`Records ${totalAbhaReportsLogs}`}
          />
        </Col>
        <Col lg={19} md={12} sm={24} xs={24}>
          <ReportFilter
            filter={filter}
            setFilter={setFilter}
            setPage={setPage}
            headers={headers}
            FilteredData={FilteredData}
            setFilteredData={setFilteredData}
          />
        </Col>
      </Row>
      <div className="tableResponsive mt-10">
        <Table
          rowKey="Id"
          className={
            isLoading
              ? "table antd_table no_data_found_hide"
              : "table antd_table"
          }
          bordered
          columns={columns}
          dataSource={
            Array.isArray(abhaCreatedList) && abhaCreatedList?.length > 0
              ? abhaCreatedList
              : []
          }
          pagination={{
            current: currentPage,
            pageSize: limit,
            total: totalAbhaReportsLogs,
            onChange(current, pageSize) {
              setPage(current);
              setCurrentPage(current);
            },
            hideOnSinglePage: true
            /* total: totalFaq,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        responsive: true */
          }}
        />
        <Modal
          style={{
            top: 20
          }}
          open={ModalNotify}
          onOk={() => {
            handleNotify();
            setModalNotify(false);
          }}
          onCancel={() => setModalNotify(false)}
          okText="Yes"
        >
          <h3>Are sure want to link and notify to user?</h3>
        </Modal>
      </div>
    </div>
  );
};

export default ReportList;
